import React from 'react';

import DOMPurify from 'dompurify';
import Link from 'next/link';
import { useRouter } from 'next/router';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import AuthService from '@services/domain/Lpc/AuthService';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './CollectMoneyBanner.module.scss';

enum MangoPayCguStatus {
    ACCEPTED = 'ACCEPTED',
}
const CollectMoneyBanner = () => {
    const { t } = useTranslateLpc('common');
    const router = useRouter();

    const onMigrate = () => {
        AuthService.setMangoPayCguStatus(MangoPayCguStatus.ACCEPTED).then(() => {
            router.push(getRoute(ROUTE.LPC.ACCEPT_MANGOPAY_CGU));
        });
    };

    return (
        <div className={css.collect_money_banner_container}>
            <Text variant={'mini_label'} color={'white'} customClass={css.collect_money_banner_container__desc}>
                {t('mangopay-migration.refused.desc-1')}
            </Text>
            <div className={css.collect_money_banner_container__actions}>
                <Text variant={'mini_label'} color={'white'} customClass={css.collect_money_banner_container__desc}>
                    {t('mangopay-migration.refused.desc-2')}
                    <Link href={getRoute(ROUTE.LPC.HELP_CENTER.DETAILS)}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(t('mangopay-migration.refused.faq')),
                            }}
                        />
                    </Link>
                    {t('mangopay-migration.refused.desc-3')}
                </Text>
                <Button
                    customClass={css.collect_money_banner_container__actions__btn}
                    variant={'tertiary-muted'}
                    onClick={onMigrate}
                >
                    {t(`mangopay-migration.refused.btn-migrate`)}
                </Button>
            </div>
        </div>
    );
};

export default CollectMoneyBanner;
